import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { userAgente } from 'src/app/empresa/interfaces/user-agente.interface';
import { RegistroService } from 'src/app/registro.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class CreateRepresentanteService {
    private apiUrl = environment.apiSiriUrl;
    perfilUsuario;
    constructor(
        private http: HttpClient,
        private keycloakService: KeycloakService,
        private registroService: RegistroService
    ) {}

    /* guardar informacion continuar el servicio......*/
    async createRepresentante() {
        try {
            this.perfilUsuario = await this.keycloakService.loadUserProfile();
            const usuarioKeycloak: userAgente = {
                cargo: this.perfilUsuario.attributes?.cargo?.[0] ?? null,
                email: this.perfilUsuario.email,
                nombre: this.perfilUsuario.firstName,
                apellido: this.perfilUsuario.lastName,
                telefono: this.perfilUsuario.attributes?.telefono?.[0] ?? null,
                usuarioId: this.perfilUsuario.id,
                username: this.perfilUsuario.username,
            };
            await this.http
                .post(
                    `${this.apiUrl}representante-agente-vigilado`,
                    usuarioKeycloak
                )
                .subscribe(
                    (response) => {
                        console.log(
                            'El usuario se a registrado correctamente ',
                            response
                        );
                        this.registroService.representanteAgenteVigilado =
                            response;
                    },
                    (error) => {
                        console.log('errrorsito ', error);
                    }
                );
        } catch (error) {
            throw error;
        }
    }

    async obtenerPerfilUsuario() {
        try {
            const userRol = await this.keycloakService.getUserRoles();
            const usuarioKeycloak =
                await this.keycloakService.loadUserProfile();
            const agenteVigilado = userRol.find(
                (role) =>
                    role === 'AgenteVigilado' || role === 'Administrador (UPRA)'
            );
            localStorage.setItem('userRol', JSON.stringify(agenteVigilado));
            this.registroService.rolUsuario = agenteVigilado;
            this.registroService.usuarioKeycloak = usuarioKeycloak;            
        } catch (error) {
            console.error('Error al cargar el perfil del usuario:', error);
        }
    }

    async creacionHisto() {
        return this.http.get(`${this.apiUrl}agente-vigilado/empresas`);
    }
}
